<template>
    <template v-if="!isLoading">
        <span class="no-file" v-if="isCheckSite">
            {{ getTranslatedText('no site setting') }}
        </span>
        <template v-else>
            <router-view />
            <Navigation v-if="!this.$route.meta.isHidenNatigation" />
            <Alert
                :showAlert="showAlert"
                :alertMessage="alertMessage"
                :alertTitle="alertTitle"
                :isTranslate="isTranslate"
            ></Alert>
        </template>
    </template>
</template>

<script>
import { configDefault, configSites } from '@/config/config';
import { version } from '../package.json';
import { isArrayEmpty, isObjEmpty, isStrEmpty } from './utils/utils';

import languageMixins from '@/mixins/language-mixins';
import utilsMixin from '@/mixins/function-utils';
import EventBus from '@/utils/EventBus';

import Alert from '@/components/common/notification/alert.vue';
import Navigation from '@/components/navigation/navigation.vue';

import SettingService from '@/services/settings/setting.service';
import { LOTTO_INSTANT } from './constants/lotto/instant-lotto';

export default {
    mixins: [utilsMixin, languageMixins],
    components: { Alert, Navigation },
    data() {
        return {
            showAlert: false,
            alertTitle: '',
            alertMessage: '',
            isCheckSite: false,
            isLoading: true,
            isTranslate: false,
            screenWidth: window.innerWidth,
        };
    },
    watch: {
        screenWidth(value) {
            if (value <= 768) {
                this.$store.state.isScreenMobile = true;
                this.$store.state.isScreenPhone = value <= 480 ? true : false;
            } else {
                this.$store.state.isScreenMobile = false;
                this.$store.state.isScreenPhone = false;
            }
        },
        $route(to) {
            document.body.style.overflow = 'auto';
            
            switch (to.path) {
                case '/loto-event':
                    this.$store.dispatch('setTabActive', 'okapiLottery');
                    break;
                case '/lotto-fixed-daily-lotto':
                    this.$store.dispatch('setTabActive', 'dailyLotto');
                    break;
                case '/instant-lotto/number':
                    this.$store.dispatch('setTabActive', LOTTO_INSTANT.SLUG_GAME);
                    break;
                default:
                    break;
            }
        },
    },
    created() {
        this.fetchSetting();
        if (this.screenWidth <= 768) {
            this.$store.state.isScreenMobile = true;
            this.$store.state.isScreenPhone = this.screenWidth <= 480 ? true : false;
        } else {
            this.$store.state.isScreenMobile = false;
            this.$store.state.isScreenPhone = false;
        }

        window.addEventListener('resize', this.handleResize);

        EventBus.on('show-notications', (data) => this.handleShowAlert(data));
    },
    mounted() {
        document.addEventListener('message', this.handleMessage);
        setInterval(function () {
            parent.postMessage({ command: 'get-location' }, '*');
        }, 5000);
    },
    unmounted() {
        EventBus.off('show-notications');
    },
    beforeMount() {
        document.removeEventListener('message', this.handleMessage);
    },
    methods: {
        async fetchSetting() {
            try {
                this.isLoading = true;
                const code = this.getParamQueryTheme('code');
                if (isStrEmpty(code)) {
                    this.isCheckSite = true;
                    this.isLoading = false;
                    return false;
                }
                const resp = await SettingService.getSettings();

                if (!isObjEmpty(resp) && !isObjEmpty(resp[code])) {
                    let config = !isArrayEmpty(resp[code].features) ? resp[code] : configDefault.default;
                    const lang = !isStrEmpty(this.getParamQueryTheme('lang'))
                        ? this.getParamQueryTheme('lang')
                        : resp[code].setup?.lang
                        ? resp[code].setup?.lang
                        : 'fr';

                    config.features = config.features.filter((feature) => {
                        if (!feature.enabled) return false;

                        if (
                            (feature.name === 'sports' && !config.enabled_game_slugs.includes('bitville-sports')) ||
                            (feature.name === 'number' && !config.enabled_game_slugs.includes('numbersbetting')) ||
                            ((feature.name === 'loto' || feature.name.includes('lotto')) &&
                                !config.enabled_game_slugs.includes('5-90-lucky')) ||
                            (feature.name === LOTTO_INSTANT.SLUG_API &&
                                !config.enabled_game_slugs.includes(LOTTO_INSTANT.SLUG_GAME))
                        ) {
                            return false;
                        }

                        if (feature.name.includes('lotto') && !config.enabled_game_slugs.includes('bitville-sports')) {
                            feature.lgCol = 1;
                        }

                        if (feature.name.includes('sports') && !config.enabled_game_slugs.includes('5-90-lucky')) {
                            feature.lgCol = 1;
                        }

                        return true;
                    });

                    this.$store.commit('SET_CONFIG', config);
                    const skin = !this.isStrEmpty(config.skin) ? config.skin : 'green';
                    await import('@/public/scss/variable/' + skin + '/_variable.scss');
                    this.$store.commit('SET_LANG', lang);
                } else {
                    this.isCheckSite = true;
                }
            } catch (error) {
                this.isCheckSite = true;
            } finally {
                this.isLoading = false;
            }
        },

        handleResize() {
            this.screenWidth = window.innerWidth;
        },

        handleMessage(event) {
            const resp = JSON.parse(event.data);
            if (resp.command === 'go-back' && !this.$store.state.isReprintDialogShowing) {
                if (this.$route.name.toLowerCase() === 'home page') {
                    parent.postMessage({ command: 'on-confirm-out-app' }, '*');
                } else if (this.$route.name.toLowerCase() === 'loto') {
                    EventBus.$emit('on-handle-back-app');
                } else {
                    this.$router.go(-1);
                }
            }
            if (resp.command === 'device-info') {
                let data = resp.data;
                data.position = resp.position;
                let versionApp = this.compareVersions(data.appVersion, version);
                this.$store.commit('SET_VERSION_APP', versionApp);


                if(isStrEmpty(data.mac) && !isStrEmpty(this.$store.state.configDevice?.mac)) {
                    data['mac'] = this.$store.state.configDevice.mac
                }

                if (isStrEmpty(data.mac) && !isStrEmpty(this.$store.state.configDevice?.mac)) {
                    data['mac'] = this.$store.state.configDevice.mac;
                }

                if (isStrEmpty(data.serial) && !isStrEmpty(this.$store.state.configDevice?.serial)) {
                    data['serial'] = this.$store.state.configDevice.serial;
                }

                if (isStrEmpty(data.uniqueId) && !isStrEmpty(this.$store.state.configDevice?.uniqueId)) {
                    data['uniqueId'] = this.$store.state.configDevice.uniqueId;
                }

                if (isStrEmpty(data.appVersion) && !isStrEmpty(this.$store.state.configDevice?.appVersion)) {
                    data['appVersion'] = this.$store.state.configDevice.appVersion;
                }

                this.$store.commit('SET_CONFIG_DEVICE', data);
            }

            if (resp.command === 'no-location-permission') {
                this.clearLocationOfDevice('no-location-permission');
            }

            if (resp.command === 'location-error') {
                this.clearLocationOfDevice(resp.error.message);
            }

            if (resp.command === 'list-bluetooth') {
                const data = resp.data;
                this.$store.commit('SET_LIST_BLUETOOTH', data);
            }
        },

        clearLocationOfDevice(errorMessage) {
            let data = this.$store.state.configDevice;
            if (!data) data = {};
            data.position = null;
            data.location_error = errorMessage;
            this.$store.commit('SET_CONFIG_DEVICE', data);
        },

        handleShowAlert(data) {
            this.showAlert = true;
            this.alertMessage = data.text;
            this.alertTitle = data.type;
            this.isTranslate = data?.isTranslate;
            setTimeout(() => {
                this.showAlert = false;
            }, 1500);
        },
    },
};
</script>
<style lang="scss">
@import '@/public/scss/main.scss';
</style>
